var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"tooltip"},[_vm._t("hoverable"),_c('span',{staticClass:"tooltiptext"},[(_vm.title)?_c('div',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]):_vm._e(),_vm._t("content")],2)],2)])}
var staticRenderFns = []

export { render, staticRenderFns }